export default "__VITE_ASSET__9a771fe0__"